<template>
  <section v-if="rte" v-html="rte.text" :class="rte.class"></section>
</template>

<script>
export default {
  name: 'ElementRTE',
  components: {},
  computed: {},
  props: {
    rte: Object,
  },
  data() {
    return {};
  },
  mounted() {},
  updated() {},
  methods: {},
};
</script>